import { register } from 'swiper/element';
import { Swiper, Navigation, Pagination, A11y } from 'swiper';

export function initializeSwiper() {
    // Register the WebComponent
    Swiper.use([ Navigation, Pagination, A11y ]);
    register();
    
    const $swiperContainers = document.querySelectorAll('[data-swiper-container]');
    
    if (!$swiperContainers?.length)
        return;
    
    $swiperContainers.forEach($swiperContainer => {
        const $swiper = $swiperContainer.querySelector('swiper-container');
        const $prev = $swiperContainer.querySelector('[data-swiper-prev]');
        const $next = $swiperContainer.querySelector('[data-swiper-next]');
        const $pagination = $swiperContainer.querySelector('[data-swiper-pagination]');
        
        Object.assign($swiper, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 16,
            navigation: {
                prevEl: $prev,
                nextEl: $next,
            },
            pagination: {
                el: $pagination,
                clickable: true,
            },
            breakpoints: {
                1024: {
                    centeredSlides: false,
                    spaceBetween: 50,
                },
            },
        });

        $swiper.initialize();
    });
}